module.exports = __webpack_public_path__ + "img/luntan.a20c5a0d.png";